import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storageEntity: Storage | null = null;

  constructor(private storage: Storage) {}

  async getStorage(): Promise<Storage> {
    if (this.storageEntity == null) {
      await this.init();
    }
    return this.storageEntity;
  }

  async init() {
    const storage = await this.storage.create();
    this.storageEntity = storage;
  }

  // Store the value
  async store(storageKey: string, value: any) {
    const encryptedValue = JSON.stringify(value);
    await (await this.getStorage()).set(storageKey, encryptedValue);
  }

  async storeMobileId(storageKey: string, value: any) {
    await (await this.getStorage()).set(storageKey, value);
  }

  // Get the value
  async get(storageKey: string) {
    const ret = await (await this.getStorage()).get(storageKey);
    let result: string;

    if (ret == null) {
      result = null;
    } else {
      result = ret;
    }

    return result;
  }

  async removeStorageItem(storageKey: string) {
    await (await this.getStorage()).remove(storageKey);
  }

  // Clear storage
  async clear() {
    await (await this.getStorage()).clear();
  }

  public async getObject(key: string) {
    const data = await this.get(key);
    return data ? JSON.parse(data) : null;
  }

  public setObject(key: string, value: any) {
    const data = JSON.stringify(value);
    this.store(key, data);
  }
}
